import React, { Component } from 'react';
import {
    Container,
    Grid,
    Segment
} from 'semantic-ui-react';
import {connect} from 'react-redux';
import qs from 'query-string';
import _ from 'underscore';
import { Item } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import ProfileMenu from '../../component/marketplace/marketplace_menu';

import {
    getUserProfilePhoto,
    getUserBenefitPlan,
    getAppConfigCountryCodes,
} from '../../actions';
import {productsListAction, purchasedProductsListAction} from '../../actions/productsActions'


class MarketplacePage extends Component {
    state = {
        mode: 1 // 1-Bio+Dependents(View + Edit), 2-My Plan, 3-Wallet, 4-Change Password
    }
    componentDidMount() {
        // this.props.getUserProfilePhoto(this.props.user.accessToken);
        // this.props.getUserBenefitPlan({accessToken: this.props.user.accessToken, userId: this.props.user.uuid});
        // this.props.getAppConfigCountryCodes()
        // const { search } = this.props.location;
        // if (search) {
        //     const parsedQueryString = qs.parse(search);
        //     if (parsedQueryString.show === 'notifications') { this.setState({ mode: 4 }); }
        // }
        this.props.productsListAction();
        this.props.purchasedProductsListAction();
    }
    handleMenuClick(e,data) {
        const nameToMode = {'Item Listing' : 1, 'Purchased': 2};
        this.setState({mode: nameToMode[data.name]});
    }
    render() {
        //console.log("TESTING");
        //console.log(this.props);
        var sortedUserNotifications = _.sortBy(this.props.userNotifications, function(o) {
            var dt = new Date(o.created);
            return -dt;
        })
        console.log("LOL", this.props.products)
        return (
            <Container fluid>
                <Grid>
                    <Grid.Row>
                        <Grid.Column>
                            <ProfileMenu
                                activeItem={this.state.mode}
                                handleMenuClick={this.handleMenuClick.bind(this)}
                            />
                            <Segment attached>
                                {
                                    (this.state.mode === 1) ?
                                    (     
                                        <Item.Group divided>
                                        {
                                            _.map(this.props.products.products, (product) => {
                                                const {
                                                    thumbnailURL,
                                                    title,
                                                    description,
                                                    price,
                                                    uuid
                                                } = product;
                                                return (
                                                    <Item key={uuid}>
                                                        <Item.Image src={thumbnailURL} />
                                                        <Item.Content>
                                                            <Item.Header>
                                                                <Link to={`/app/product/view?type=1&id=${uuid}`}>
                                                                    {title}
                                                                </Link>
                                                                <p>{description}</p>
                                                                <p>$ {price/100}</p>
                                                            </Item.Header>
                                                        </Item.Content>
                                                    </Item>
                                                );
                                            })
                                        }
                                    </Item.Group>
                                    )
                                    :
                                    null
                                }
                                {
                                    (this.state.mode === 2) ?
                                    (
                                        <Item.Group divided>
                                        {
                                            _.map(this.props.products.purchasedProducts, (product) => {
                                                return (
                                                    <Item key={product.uuid}>
                                                        <Item.Image src={product.product.thumbnailURL} />
                                                        <Item.Content>
                                                            <Item.Header>
                                                                <Link to={`/app/product/redeem?type=1&id=${product.uuid}`}>
                                                                    {product.product.title}
                                                                </Link>
                                                                { product.redeemedDate && <p>Redeemed</p> }
                                                                <p>{ "Quantity: " + product.quantity }</p>
                                                                <p>{ moment(product.created).format('DD MMM YYYY h:mm A') }</p>
                                                            </Item.Header>
                                                        </Item.Content>
                                                    </Item>
                                                );
                                            })
                                        }
                                    </Item.Group>
                                    )
                                    :
                                    null
                                }
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        );
    }

}

const mapStateToProps = state => {
    console.log("PRODUCTS")
    console.log(state.products)
    return {
        user: state.user.user,
        profilePhoto: state.user.profilePhoto,
        userNotifications: state.user.notifications,
        benefitPlans: state.user.benefitPlans,
        benefits: state.user.benefits,
        claimOptions: state.claimOptions,
        countryCodeOptions: state.appConfig.countryCodes,
        products: state.products,
    }
}

export default connect(mapStateToProps,{
    getUserProfilePhoto,
    getUserBenefitPlan,
    getAppConfigCountryCodes,
    productsListAction,
    purchasedProductsListAction
})(MarketplacePage);
